// Fetches a same/cross-origin image URL and resolves it to a base64 data URL,
// which jsPDF's addImage() / ExcelJS's addImage() need to avoid tainted-canvas/CORS failures.
export default function loadImageAsDataUrl(url) {
  if (!url) return Promise.resolve(null);
  return fetch(url)
    .then(res => (res.ok ? res.blob() : null))
    .then(
      blob =>
        blob &&
        new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        })
    )
    .catch(() => null);
}

// Tries the given URL first (a tenant/branch logo, which may be missing, expired,
// or blocked by CORS); falls back to a bundled default logo if that fails.
export async function resolveLogoDataUrl(url, fallbackUrl) {
  const resolved = await loadImageAsDataUrl(url);
  if (resolved) return resolved;
  return loadImageAsDataUrl(fallbackUrl);
}
